module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-35-d94a61487455c466b09371b10744fa35.svg";